import React, { useState } from 'react';
import { PiShieldCheck } from 'react-icons/pi';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import AccountPageHeader from '../../../components/AccountPageHeader';
import PageIntro from '../../../components/PageIntro';
import { PasswordField } from '../../../components/FormFields';
import { auth } from '../../../firebaseConfig';
import '../../../styles/account-pages.css';

const Security = () => {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChangePassword = async (event) => {
    event.preventDefault();
    setError('');
    setSuccessMessage('');

    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    setIsSubmitting(true);
    try {
      const user = auth.currentUser;
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      setNewPassword('');
      setConfirmPassword('');
      setCurrentPassword('');
      setSuccessMessage('Senha alterada com sucesso.');
    } catch (changeError) {
      setError('Não foi possível alterar sua senha. Verifique a senha atual e tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="account-page">
      <AccountPageHeader title="Segurança" onBack={() => navigate(-1)} />
      <main className="account-content">
        <PageIntro description="Gerencie a proteção e as credenciais da sua conta." />
        <section className="account-section" aria-labelledby="security-title">
          <div className="account-section__heading">
            <h2 id="security-title">Alterar senha</h2>
            <p>Confirme sua senha atual antes de definir uma nova.</p>
          </div>
          <div className="account-security-note">
            <PiShieldCheck size={22} aria-hidden="true" />
            <div>
              <strong>Conta protegida por senha</strong>
              <span>{auth.currentUser?.email || 'E-mail da conta Nara'}</span>
            </div>
          </div>
          <form className="account-form" onSubmit={handleChangePassword}>
            {error && <div className="account-alert account-alert--error" role="alert">{error}</div>}
            {successMessage && <div className="account-alert account-alert--success" role="status">{successMessage}</div>}
            <PasswordField id="current-password" label="Senha atual" value={currentPassword} onChange={setCurrentPassword} required disabled={isSubmitting} />
            <PasswordField id="new-password" label="Nova senha" autoComplete="new-password" value={newPassword} onChange={setNewPassword} required disabled={isSubmitting} />
            <PasswordField id="confirm-password" label="Confirmar nova senha" autoComplete="new-password" value={confirmPassword} onChange={setConfirmPassword} required disabled={isSubmitting} />
            <button className="account-primary-button" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Alterando…' : 'Alterar senha'}
            </button>
          </form>
        </section>
      </main>
    </div>
  );
};

export default Security;